module.exports = __webpack_public_path__ + "img/47_11.c0fae0e5.png";